var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "874C01A9-AF59-4009-B76C-56005C745087") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "3.28125e-05 0.2055375 7.63747031 0.2055375 7.63747031 7.875 3.28125e-05 7.875"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Dashboard",
    transform: "translate(-1273.000000, -675.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expand",
    transform: "translate(1273.000000, 675.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 8.125000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.28125e-05,0.765975 C0.765548438,1.52985 1.53172031,2.29306875 2.29625156,3.05792813 C2.43800156,3.19935 2.57417344,3.34602188 2.70870469,3.48613125 C3.80857969,2.38067813 4.89336094,1.290975 5.97420469,0.2055375 C6.54547031,0.781725 7.08490781,1.32608438 7.63747031,1.88389688 C6.56581406,2.9512875 5.47611094,4.036725 4.36901719,5.139225 C5.28481406,6.04944375 6.18814219,6.94686563 7.12198594,7.87513125 L3.28125e-05,7.87513125 L3.28125e-05,0.765975 Z",
    id: "Fill-1",
    fill: "#323846",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L16,7.30047552 C15.0559191,6.35418005 14.1310982,5.42745148 13.2022226,4.49633723 C12.0631758,5.63897635 10.9464301,6.7593497 9.83407706,7.875 C9.25424783,7.29440303 8.69739552,6.73674656 8.125,6.16390888 C9.23667725,5.05837939 10.3588293,3.94272908 11.4911182,2.81628325 C10.5470372,1.87032515 9.61343109,0.935162576 8.67914915,0 L16,0 Z",
    id: "Fill-4",
    fill: "#323846"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.3a0464a0714e278c504714ca6498668d.svg";
export { ForwardRef as ReactComponent };